import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import type { OpsPlatformSummaryDto } from '@/types/dtos/ops/ops-platform.dto';

export const PLATFORM_SUMMARY_QUERY_KEY = 'ops-platform-summary';

export function usePlatformSummaryQuery() {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [PLATFORM_SUMMARY_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/ops/platform-summary`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' }) as Promise<OpsPlatformSummaryDto>;
    },
    refetchInterval: 15_000,
  });
}
